const isRTL = str => {
  if (Object.prototype.toString.call(str) === '[object String]') {
    return /[\u0590-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(str);
  }

  return false;
};

export default isRTL;
